import { Grid, IconButton, Stack } from "@mui/material";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import { format } from "date-fns";
import FeatherIcon from "feather-icons-react";
import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AppDataContext } from "../../components/context/app-data-context.jsx";
import TableComponent from "../../components/table/list.jsx";
import { DATE_FORMAT } from "../../helpers/constant.js";
import Utils from "../../utils.js";
import AddTracker from "./add-tracker.jsx";
import SetAlertConfirmButton from "./alert-confirm.jsx";
import { CustomTooltip } from "../../consts.js";
import { AuthContext } from "../../components/auth/AuthContext.js";

function Trackers() {
    const navigate = useNavigate();
    const { currentNonAdminGroup } = React.useContext(AuthContext);
    const [data, setData] = React.useState([]);
    const [companyDT, setCompanyDT] = React.useState({});
    const [newCampDiag, setNewCampDiag] = React.useState(false);
    const [dataLoaded, setDataLoaded] = React.useState(false);
    const [spinner, setSpinner] = React.useState(false);
    const AppDataContextDTO = useContext(AppDataContext);

    async function getCompanyData() {
        Utils.sendProgressBar(true);
        setSpinner(true);
        let company = await Utils.genericList("listCompanies", {
            filter: { internalname: { eq: currentNonAdminGroup } },
        });
        company = company.data.listCompanies.items[0].id;
        company = await Utils.genericGet("getCompany", company);
        company = company.data.getCompany;
        company.trackers = JSON.parse(company.trackers);
        company.campaigns?.items?.forEach(
            (z) => (z.trackers = JSON.parse(z.trackers))
        );
        setCompanyDT(company);
        let trackers = [];
        company.trackers.forEach((z) => {
            if (!z.alert) {
                z.alert = false;
            }
            let found = trackers.find((a) => a.name === z.name);
            if (!found) {
                z.campaigns = [];
                trackers.push(z);
            }
        });
        company.campaigns?.items?.forEach((z) => {
            z.trackers.forEach((b) => {
                if (!b.alert) {
                    b.alert = false;
                }
                let found = trackers.find((a) => a.name === b.name);
                if (!found) {
                    b.campaigns = [];
                    trackers.push(b);
                } else {
                    found.campaigns.push(z.name);
                }
            });
        });
        setData(trackers);
        setSpinner(false);
    }

    function navigateToTracker(newTrackerName) {
        let today = new Date(Date.now());
        today = today.toISOString().substr(0, 10);

        navigate("/insight-phrases", {
            state: {
                tracker: { name: newTrackerName, created: today, phrases: [] },
                company: companyDT,
            },
        });
    }

    useEffect(() => {
        try {
            AppDataContextDTO.clearAppData();
        } catch (error) {

        }
        if (!dataLoaded && currentNonAdminGroup) {
            const fetchData = async () => {
                await getCompanyData(); // Your async data fetching function
                setDataLoaded(true); // Mark data as loaded
            };
            fetchData();
        }

        window.scrollTo(0, 0); // Scroll to top when component mounts
    }, [dataLoaded, currentNonAdminGroup]);

    // define table headers
    const columns = [
        {
            label: "Insight Name",
            key: "name",
            sortable: true,
            renderItem: (row) => row.name || "-",
        },
        {
            label: "Phrases",
            key: "phrases",
            sortable: true,
            renderItem: (row) => row.phrases.length || 0,
        },
        {
            label: "Campaigns",
            key: "campaigns",
            sortable: true,
            style: { width: "44%" },
            renderItem: (row) => (<Stack direction="row" flexWrap="wrap" gap={1}>
                {row.campaigns.map((a, aidx) => (
                    <Chip
                        label={a}
                        key={aidx}
                        size="small"
                    />
                ))}
            </Stack>)
        },
        {
            label: "Created",
            key: "created",
            sortable: true,
            renderItem: (row) => (<>
                <div>
                    {format(new Date(row.created), DATE_FORMAT)}
                </div>
                <div style={{
                    fontWeight: 500,
                }}>
                    {row.company}
                </div>
            </>)
        },
        {
            label: "Set Alert",
            key: "alert",
            sortable: true,
            renderItem: (row) => (
                <SetAlertConfirmButton
                    id={companyDT.id}
                    alertData={row}
                    onSuccess={() => {
                        const _data = Object.assign([], data);
                        const index = _data.findIndex(item => item.name === row.name)
                        _data[index].alert = !_data[index].alert;
                        setData([..._data]);
                    }}
                />)
        },
        {
            label: "Edit",
            sortable: false,
            style: { width: "8%" },
            renderItem: (row) => (<CustomTooltip title={"Edit"}>
                <IconButton aria-label="Edit" size="small" color="inherit" onClick={() =>
                    navigate("/insight-phrases", {
                        state: {
                            tracker: row,
                            company: companyDT,
                        },
                    })
                }>
                    <FeatherIcon icon="edit-2" size={20} />
                </IconButton>
            </CustomTooltip>
            )
        }
    ];

    // After new insight added
    const handleCloseAddTracker = async (tracker) => {
        if (tracker === null) setNewCampDiag(false);
        else {
            Utils.sendProgressBar(true);
            setNewCampDiag(false);
            await getCompanyData();
            navigateToTracker(tracker);
        }
    }

    const headerActionButtons = () => {
        return (
            <Button
                variant="contained"
                onClick={() => setNewCampDiag(true)}
                startIcon={<FeatherIcon icon="plus-circle" size={20} />}
                disabled={spinner || true} // VOC-199 DISABLED FOR DEMO
            >
                Create New Insight
            </Button>
        )
    }

    return (
        <Grid display="flex" flexDirection="column" flexGrow="1" overflow="auto">
            <Grid
                className="vocalysed-home-upadted campaigns"
                container
                spacing={0}
                direction="column"
                flexWrap="nowrap"
                flexGrow={1}
                paddingTop={2}
                paddingX={3}
                paddingBottom={3}
                overflow="auto"
            >
                <TableComponent
                    headerActionButtons={headerActionButtons}
                    spinner={spinner}
                    data={data}
                    columns={columns}
                    pagination={true}
                    searchKeys={["name", "campaigns"]}
                    defaultOptions={{ sortKey: "alert", sortOrder: "asc" }}
                    noDataMessage={"No insights found."}
                />
            </Grid>
            {/* Add Tracker Modal */}
            <AddTracker
                id={companyDT.id}
                trackers={companyDT.trackers}
                open={newCampDiag}
                onClose={handleCloseAddTracker}
            />
        </Grid>
    );
}

export default Trackers;